import styles from "./ReorderDialog.module.scss";
import { useSortable } from "@dnd-kit/sortable";
import { ReactNode } from "react";
import { Icon, IconType } from "../../icons/Icon";

interface ISortableItemProps {
  id: number;
  children: ReactNode;
  isDragOverlay?: boolean;
  isBeingDragged?: boolean;
}

export const SortableItem = ({
  id,
  children,
  isBeingDragged = false,
}: ISortableItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    // Only apply Y-axis translation to prevent horizontal movement and infinite scroll issues
    transform: transform ? `translate3d(0, ${transform.y}px, 0)` : undefined,
    transition,
    // Hide the original item when being dragged - the DragOverlay shows the visual
    opacity: isBeingDragged ? 0.4 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={styles.item}
      {...attributes}
    >
      <div className={styles.item_handle} {...listeners}>
        <Icon type={IconType.DragHandle} width={20} height={20} color="rgba(255, 255, 255, 0.7)" />
      </div>
      <div className={styles.item_content}>{children}</div>
    </div>
  );
};
